import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getRequestSubcategoryFormThunk = createAsyncThunk(
    `RequestSubcategoryFormSlicer/getRequestSubcategoryFormThunk`,
    async (subcategoryId, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const { data } = await conciergeApiClient.get(`/Form/get-form-by-subcategory?subcategoryId=${subcategoryId}`, { headers });
        return data;
    }
);

const initialState = {
    dataRequestSubcategoryForm: {},
    loadingRequestSubcategoryForm: false,
    errorRequestSubcategoryForm: false,
};

const RequestSubcategoryFormSlicer = createSlice({
    name: 'requestSubcategoryForm',
    initialState,
    reducers: {
        resetDataRequestSubcategoryForm: (state) => {
            state.dataRequestSubcategoryForm = {};
            state.loadingRequestSubcategoryForm = false;
            state.errorRequestSubcategoryForm = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRequestSubcategoryFormThunk.pending, (state) => {
            state.dataRequestSubcategoryForm = {};
            state.loadingRequestSubcategoryForm = true;
            state.errorRequestSubcategoryForm = false;
        });
        builder.addCase(getRequestSubcategoryFormThunk.fulfilled, (state, action) => {
            state.loadingRequestSubcategoryForm = false;
            state.dataRequestSubcategoryForm = action.payload;
            state.errorRequestSubcategoryForm = false;
        });
        builder.addCase(getRequestSubcategoryFormThunk.rejected, (state) => {
            state.loadingRequestSubcategoryForm = false;
            state.errorRequestSubcategoryForm = true;
            state.dataRequestSubcategoryForm = {};
        });
    },
});

export const { resetDataRequestSubcategoryForm } = RequestSubcategoryFormSlicer.actions;
export default RequestSubcategoryFormSlicer.reducer;